import React from 'react';
import ReportingDonationsLybuntSybuntPage from '../components/ReportingDonationsLybuntSybuntPage';

const ReportingDonationsLybuntSybuntApp = (props) => (
  <ReportingDonationsLybuntSybuntPage {...props} />
);

export default ReportingDonationsLybuntSybuntApp;
